module.exports = __webpack_public_path__ + "5a634e9fa3e282dfc3cf1a4201af293e.png";